import React, { useState, useEffect, useCallback } from "react";
import { Container } from "@mui/material";
import { grey } from "@mui/material/colors";
import TicketsTabBar from "../../components/Tickets/TicketsTabBar";
import Title from "../../components/SharedComponents/Title";
import SearchBar from "../../components/SharedComponents/SearchBar";
import { getTickets } from "../../api/ticketsApi";
import { notification } from "../../utils/Notifications";
import useLogout from "../../hooks/auth/authHook";
const Tickets = () => {
  const [logout] = useLogout();

  const [tickets, setTickets] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("registrado");
  const [counters, setCounters] = useState({
    registrado: 0,
    procesando: 0,
    terminado: 0,
  });

  const fetchTickets = useCallback((status) => {
    setIsLoading(true);
    
    getTickets({ status })
      .then((response) => {
        if (response.data.status_Code === 200) {
          // Mapear los reports del API a tickets
          const mappedTickets = (response.data.reports || []).map((report) => ({
            id: report.report_id,
            reportNumber: `REP-${report.report_id}`,
            guideNumber: report.guide,
            provider: report.shipping_company || "N/A",
            reportType: report.report_type,
            clientName: report.client?.full_name || "N/A",
            clientId: report.client?.id_user || "N/A",
            reportDate: report.created_at,
            lastUpdateDate: report.last_updated || "N/A",
            status: report.status,
            // Datos adicionales del API
            administratorResponse: report.administrator_response,
            clientEmail: report.client?.email,
            images: report.images || {},
            address: report.address || {},
            package_info: report.package_info,
          }));
          
          setTickets(mappedTickets);
          
          // Guardar los counters
          if (response.data.counters) {
            setCounters({
              registrado: response.data.counters.registrado || 0,
              procesando: response.data.counters.procesando || 0,
              terminado: response.data.counters.terminado || 0,
            });
          }
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al obtener los tickets",
            type: "error",
          });
        }
      })
      .catch(() => {
        notification({ text: "Error de conexión, revisa tu conexión a internet", type: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [logout]);

  // Cargar datos iniciales al montar el componente
  useEffect(() => {
    fetchTickets(currentStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      style={{ minHeight: "100%", backgroundColor: grey[100], padding: "24px" }}
    >
      <Title title="Tickets" />

      <TicketsTabBar 
        tickets={tickets} 
        search={search} 
        setSearch={setSearch}
        isLoading={isLoading} 
        fetchTickets={fetchTickets}
        currentStatus={currentStatus}
        setCurrentStatus={setCurrentStatus}
        counters={counters}
      />
    </Container>
  );
};

export default Tickets;

